import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_CONTACTS',
    icon: 'UserIcon',
    action: constants.action.permissionContactView,
    resource: constants.resource.contact,
    route: 'contacts-list',
  },
]
